module.exports = __webpack_public_path__ + "assets/images/781a9677dfb058a26a4a9c5349e38c43.png";